import React, { useState } from "react";
import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import { useStepperData } from "../../Helpers/Contexts/stepperContext";
import Stepper from "./Stepper";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import KenLoader from "../../GlobalComponents/KenLoader";

interface Step {
  label: string;
  content: React.ReactNode;
  validate?: () => boolean;
}

// interface ReusableStepperProps {
//   steps: Step[];
//   onFinalSubmit: (data: Record<string, any>) => Promise<void>;
// }
interface ReusableStepperProps {
  loading?: any;
  setLoading?: any;
  steps: Step[];
  onFinalSubmit: (data: Record<string, any>) => Promise<void>;
  onStepUpdate?: (data: Record<string, any>, step: number) => Promise<void>;
}

const ReusableStepper: React.FC<ReusableStepperProps> = ({
  loading,
  setLoading,
  steps,
  onFinalSubmit,
  onStepUpdate,
}) => {
  const theme = useTheme();
  const { formData } = useStepperData();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleNext = async () => {
    const step = steps[activeStep];
    if (step.validate && !step.validate()) return;

    try {
      if (activeStep === steps.length - 1) {
        setLoading(true);
        await onFinalSubmit(formData);
      } else {
        if (onStepUpdate) {
          await onStepUpdate(formData, activeStep);
        }
        setActiveStep((prev) => prev + 1);
      }
    } catch (err) {
      console.error("Error during step update:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    if (activeStep === 0) {
      navigate(-1);
    } else setActiveStep((prev) => Math.max(prev - 1, 0));
  };

  return (
    <>
      {loading ? (
        <KenLoader />
      ) : (
        <Box
          component={"div"}
          sx={{ height: `${isMobile ? "100%" : "100%"}`, width: "100%" }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "space-between",
              height: "100%",
              width: "100%",
            }}
          >
            <Stepper
              steps={steps.map((s) => s.label)}
              activeStep={activeStep}
            />
            <Box
              sx={{
                pt: "20px",
                width: "100%",
                mt: 2,
                height: "80%",
                overflowY: "auto",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              {steps[activeStep].content}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                mt: "auto",
                gap: "10px",
              }}
            >
              <Button
                onClick={handleBack}
                variant="outlined"
                sx={{
                  borderRadius: "50px",
                  border: "1px solid #E35C16",
                  color: "#E35C16",
                  "&:hover": {
                    border: "1px solid #E35C16",
                  },
                }}
                // disabled={activeStep === 0}
              >
                <ArrowBackIosNewIcon />
              </Button>
              <Button
                variant="contained"
                onClick={handleNext}
                sx={{
                  width: "100%",
                  height: "60px !important",
                  backgroundColor: "#E35C16 !important",
                  color: "#fff !important",
                  fontSize: "18px !important",
                  fontWeight: "600 !important",
                  borderRadius: "60px !important",
                  "&:hover": {
                    backgroundColor: "#E35C16 !important",
                  },
                }}
                disabled={loading}
              >
                {activeStep === steps.length - 1 ? "Submit" : "Next"}
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default ReusableStepper;
